import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import {setIsItemAndOrderLevelApproval, setRequestApproverActionData, setQuantityApproverActionData, setCapitalLeaseExpenditureData, setRequisitionApprovalData} from 'Store/OrderManagement/Approval/ApprovalAction';
import { GET_ITEM_AND_ORDER_LEVEL_APPROVAL, GET_APPROVER_ACTIONS_DATA, GET_CAPITAL_LEASE_EXPENDITURE_DATA } from 'Store/OrderManagement/Approval/ApprovalType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';

function* ItemAndOrderLevelApprovalSaga(req: any): any {

    let payloadData : IPayload = {                
        apiMethod : apiMethod.POST,
        apiType : apiType.OrderManagement,
        endpoint : `orderapproval`,
        payload : req?.val
    }
    try {
        yield put(globalLoaderText("Updating order...."));
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData );
        if(response) {
            yield put(setIsItemAndOrderLevelApproval(response?.isSuccess))
            yield put(setRequisitionApprovalData(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setIsItemAndOrderLevelApproval(false))
        yield put(globalLoaderText(""));
    }
}

function* getApproverActionDataSaga(req: any): any {
    try {
       // const response = yield call(api.callOrderGet, `masterdata/dropdown/approveractions`);
       const orderLevelApprovalOption = [
        { disabled: false, group: null, selected: false, value: '1', text: 'Approve', key:"Approve" },
            { disabled: false, group: null, selected: false, value: '2', text: 'Reject', key:"Reject" },
            { disabled: false, group: null, selected: false, value: '3', text: 'Request More Info', key:"Request More Info" }
       ]
       const quantityLevelApprovalOption = [
        { disabled: false, group: null, selected: false, value: '1', text: 'Approve', key:"Approve" },
            { disabled: false, group: null, selected: false, value: '2', text: 'Reject', key:"Reject" },
            { disabled: false, group: null, selected: false, value: '3', text: 'Request More Info', key:"Request More Info" }
       ]
        if(req?.val == "OrderLevel"){
            yield put(setRequestApproverActionData(orderLevelApprovalOption))
        }else if(req?.val == "QuantityLevel"){
            yield put(setQuantityApproverActionData(quantityLevelApprovalOption))
        }
        
    } catch (error) {
        yield put(setQuantityApproverActionData([]))
        yield put(setRequestApproverActionData([]))
    }
}

function* getCapitalLeaseExpenditureSaga(): any {
    try {
        const response: any = [
            {
                Type: 'Planned',
                Budget: '$0.00',
                Spent: '$0.00',
                OpenPo: '$0.00',
                ApprovedRequest: '$0.00',
                ThisOrder: '0.00',
                OverUnder: '0.00'
            },
            {
                Type: 'Unplanned',
                Budget: '$0.00',
                Spent: '$0.00',
                OpenPo: '$0.00',
                ApprovedRequest: '$0.00',
                ThisOrder: '0.00',
                OverUnder: '0.00'
            },
            {
                Type: 'Growth',
                Budget: '$0.00',
                Spent: '$0.00',
                OpenPo: '$0.00',
                ApprovedRequest: '$0.00',
                ThisOrder: '0.00',
                OverUnder: '0.00'
            }
        ]
        yield put(setCapitalLeaseExpenditureData(response))
    } catch (error) {
        yield put(setCapitalLeaseExpenditureData([]))
    }
}

function* watchApproval() {
    yield takeEvery(GET_ITEM_AND_ORDER_LEVEL_APPROVAL, ItemAndOrderLevelApprovalSaga);
    yield takeEvery(GET_APPROVER_ACTIONS_DATA, getApproverActionDataSaga)
    yield takeEvery(GET_CAPITAL_LEASE_EXPENDITURE_DATA, getCapitalLeaseExpenditureSaga)
}

export default function* combinedSaga() {
    yield all([
        watchApproval()
    ])
  }
